import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import getServerSidePortfolioMonitorBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSidePortfolioMonitorBreadcrumbs';
import PortfolioMonitorPage from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioMonitorPage';
import getServerSidePortfolios from '@/creditflowresearch/application/PortfolioMonitor/serverSide/getServerSidePortfolios';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const [breadcrumbs, purePortfoliosList] = await Promise.all([
    getServerSidePortfolioMonitorBreadcrumbs(),
    getServerSidePortfolios(context),
  ]);
  return ({
    props: {
      breadcrumbs,
      purePortfoliosList,
    },
  });
}, { needsLegacyDictionaries: false });

const CusipPortfolioMonitor = (props) => (
  <PageContentLayout>
    <PortfolioMonitorPage { ...props } />
  </PageContentLayout>
);

export default CusipPortfolioMonitor;
